import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from 'helpers/api'
import { useApplicationStore } from 'hooks/application'
import { SIGN_IN } from 'routes'
import Button from 'components/button'
import Input from 'components/input'

const SendEmailVerificationCode: React.FC = () => {
  const [emailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState<string>('')
  const [sendVerification, setSendVerification] = useState(false)
  const { displayErrorMessage } = useApplicationStore()

  useEffect(() => {
    document.title = 'Morta | Verify Email'
  }, [])

  const handleEmailVerification = async () => {
    if (sendVerification) return
    setSendVerification(true)
    try {
      await api.sendEmailVerification(email)
      setEmailSent(true)
      setSendVerification(false)
    } catch (e) {
      displayErrorMessage(e)
      setSendVerification(false)
    }
  }

  const emailError = email === '' && sendVerification

  return (
    <div className="bg-really-light-blue flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-8">
      <div className="h-fit flex flex-col bg-surface border border-divider-strong p-8 shadow-heavy rounded text-body w-[550px]">
        {emailSent ? (
          <div>
            <h1>Verification Email Sent</h1>
            <p>We have sent an email to your account with details on how to verify your email address.</p>
            <p className="border-t border-divider mt-5 pt-5">
              Return to <Link to={SIGN_IN}>Sign In</Link>
            </p>
          </div>
        ) : (
          <div>
            <h1 className="mb-4 text-2xl">Verify Your Email</h1>
            <br />
            <Input type="text" placeholder="Your email address" onChange={(event) => setEmail(event.target.value)} />
            {emailError && <p className="text-red mt-4">Your email address cannot be blank</p>}
            <Button
              className="mt-5"
              onClick={() => handleEmailVerification()}
              disabled={emailError || sendVerification}
            >
              Send Email Verification
            </Button>
            <p className="border-t border-divider mt-5 pt-5">
              Return to <Link to={SIGN_IN}>Sign In</Link>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SendEmailVerificationCode
